import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { LaborSetupItem } from 'src/app/shared/models/laborScheduling/LaborSetup.item';

@Component({
	selector: 'app-employee-scheduling-setup-global-rules',
	templateUrl: './employee-scheduling-setup-global-rules.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class EmployeeSchedulingSetupGlobalRulesComponent implements OnInit {
	@Input() laborSetup: LaborSetupItem;
	@Output() laborSetupChange = new EventEmitter<LaborSetupItem>();

	@Output() changesToSaveChange = new EventEmitter<boolean>();

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {}

	changesToSave() {
		this.changesToSaveChange.emit(true);
	}
}
